import React, { Fragment } from 'react';
import {
  Accordion,
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Form,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { SelectField } from 'Common/SemanticWrapper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ON_HAND_REPORT_LISTING_FORM_NAME } from 'Common/FormEnum';
import { OnHandReportListingEnum } from 'Common/FieldEnum';
import { getInventoryValue } from 'Common/FormHelper';
import { PrintGroupByTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';

import { SiteGridContainer } from '../containers/onhandreportlisting/SiteGridContainer';
import { ItemGridContainer } from '../containers/onhandreportlisting/ItemGridContainer';
import { activeStatusOptions } from '../helper/listing';
import { printOptions } from '../helper/onHand';

const OnHandReportListing = props => {
  const {
    handleCollapsePanelClick,
    activeIndexes,
    handleChange,
    filterValues,
    clearFilters,
    printOptionsValue,
    onHandItems,
    loadingOnHandItems,
    bidGroupData,
    itemGroupData,
    acctCategoryData,
    vendorData,
    loadingPrint,
    handleClickPrint,
    handleSubmit,
    setItemGridInstance,
    setSiteGridInstance,
    siteReactTableRef,
    itemReactTableRef,
    printLoading,
  } = props;

  const fields = [
    {
      name: OnHandReportListingEnum.ItemStatus,
      component: SelectField,
      type: 'text',
      options: activeStatusOptions,
      label: 'ITEM STATUS',
      maxLength: 20,
    },
    {
      name: OnHandReportListingEnum.BidGroup,
      component: SelectField,
      type: 'text',
      options: bidGroupData,
      label: 'BID GROUP',
      maxLength: 20,
    },
    {
      name: OnHandReportListingEnum.ItemGroup,
      component: SelectField,
      type: 'text',
      options: itemGroupData,
      label: 'ITEM GROUP',
    },
    {
      name: OnHandReportListingEnum.AccountCategory,
      component: SelectField,
      type: 'text',
      options: acctCategoryData,
      label: 'ACCT. CATEGORY',
    },
    {
      name: OnHandReportListingEnum.VendorId,
      component: SelectField,
      type: 'text',
      options: vendorData,
      label: 'DISTRIBUTOR',
    },
  ];
  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndexes.indexOf(0) !== -1}
            index={0}
            onClick={handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>

          <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
            <Grid className={'remove-spacing'}>
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Column width={3} floated={'right'} textAlign={'right'}>
                <Button
                  type={'button'}
                  content="Clear Filters"
                  onClick={clearFilters}
                />
              </Grid.Column>
            </Grid>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndexes.indexOf(1) !== -1}
            index={1}
            onClick={handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Print</span>
          </Accordion.Title>

          <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
            <Grid className="tight">
              <Grid.Row columns={3}>
                <Grid.Column width={12}>
                  <ReduxFormButtonGroup
                    options={printOptions}
                    value={printOptionsValue}
                    formName={ON_HAND_REPORT_LISTING_FORM_NAME}
                    fieldName={OnHandReportListingEnum.PrintOptions}
                    loading={loadingPrint}
                    type={'button'}
                    label={'Sort By'}
                  />
                </Grid.Column>

                <Grid.Column
                  width={4}
                  floated={'right'}
                  textAlign={'right'}
                  verticalAlign={'middle'}
                >
                  <Button
                    content="Print On Hand Summary"
                    onClick={handleClickPrint}
                    loading={printLoading}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>

        <Divider horizontal />

        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Header as="h4" className={'text-orange'}>
                Site
              </Header>
            </Grid.Column>
            <Grid.Column width={1} />
            <Grid.Column width={5}>
              <Header as="h4" className={'text-orange'}>
                On Hand
              </Header>
            </Grid.Column>
            <Grid.Column width={5} floated={'right'} textAlign={'right'}>
              <Header as="h4" className={'text-orange'}>
                Inventory Value $ {getInventoryValue(onHandItems)}
              </Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                component={SiteGridContainer}
                name={OnHandReportListingEnum.SiteIds}
                {...{
                  filterValues,
                  setSiteGridInstance,
                  reactTableRef: siteReactTableRef,
                }}
              />
            </Grid.Column>

            <Grid.Column width={10}>
              <Field
                component={ItemGridContainer}
                name={OnHandReportListingEnum.ItemIds}
                {...{
                  dataSource: onHandItems,
                  loadingOnHandItems,
                  setItemGridInstance,
                  reactTableRef: itemReactTableRef,
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

OnHandReportListing.propTypes = {
  onHandItems: PropTypes.array.isRequired,
  bidGroupData: PropTypes.array.isRequired,
  itemGroupData: PropTypes.array.isRequired,
  acctCategoryData: PropTypes.array.isRequired,
  vendorData: PropTypes.array.isRequired,
  filterValues: PropTypes.object.isRequired,
  handleCollapsePanelClick: PropTypes.func,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  getOnHandItems: PropTypes.func,
  handleClickPrint: PropTypes.func,
  handleSubmit: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  setSiteGridInstance: PropTypes.func,
  activeIndexes: PropTypes.array,
  printOptionsValue: PropTypes.number,
  loadingOnHandItems: PropTypes.bool,
  loadingPrint: PropTypes.bool,
  siteReactTableRef: PropTypes.object,
  itemReactTableRef: PropTypes.object,
  printLoading: PropTypes.bool,
};

OnHandReportListing.defaultProps = {
  handleCollapsePanelClick: () => {},
  handleChange: () => {},
  clearFilters: () => {},
  getOnHandItems: () => {},
  handleClickPrint: () => {},
  handleSubmit: () => {},
  setItemGridInstance: () => {},
  setSiteGridInstance: () => {},
  activeIndexes: 0,
  printOptionsValue: PrintGroupByTypeEnum.Item,
  loadingOnHandItems: false,
  loadingPrint: false,
  siteReactTableRef: null,
  itemReactTableRef: null,
  printLoading: false,
};

export default OnHandReportListing;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/components/OnHandReportListing.js